import { useState, useCallback } from 'react';
import { AlgoliaLearnosityItem } from '../types';

/**
 * Custom hook for managing the tags dialog state and operations
 */
const useTagDialog = () => {
  const [tagDetailsOpen, setTagDetailsOpen] = useState<string | null>(null);
  const [currentHit, setCurrentHit] = useState<AlgoliaLearnosityItem | null>(null);

  const handleTagsOpen = useCallback((hit: AlgoliaLearnosityItem) => {
    setTagDetailsOpen(hit.reference);
    setCurrentHit(hit);
  }, []);

  const handleTagsClose = useCallback(() => {
    setTagDetailsOpen(null);
    setCurrentHit(null);
  }, []);

  return {
    tagDetailsOpen,
    currentHit,
    handleTagsOpen,
    handleTagsClose,
  };
};

export default useTagDialog;
